
<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="seismicswathnoForm">
      <div class="">
        <h3 class="form_name">SeismicSwathNo</h3>
         
          <div class="input">
            <label for=""> Swath No</label>
            <input type="text" class="default_input reference-form" formControlName="SwathNo" />
          </div>
  
          <div class="input">
            <label for=""> Swath Name</label>
            <input type="text" class="default_input reference-form" formControlName="SwathName" />
          </div>
  
          <div class="input">
            <label for="">Swath Description</label>
            <input type="text" class="default_input reference-form" formControlName="SwathDescription" />
          </div>
          
  
        <div class="btn_holder">
          <button class="default_primary-button" (click)="addNew(seismicswathnoForm.value)">Add</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>
  
        </div>
  
      </div>
    </form>
      <div class="display_table">
        <div class="search_container">
          <input type="text" class="default_input search"
          placeholder="Search for SeismicSwathNo"
          [formControl]="control"
          [appAutocomplete]="autocomplete"
          />
          <em class="ti-search"></em> 
  
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="(seismicswathnos | filterReference: control.value) as result"
              >
                <app-option
                  (click)="selectSeismicSwathNo(option.id)"
                  *ngFor="let option of result"
                  [value]="option.SwathName"
                >
                  {{ option.SwathName }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
        </div>
  
        <div class="head" >
          <span class="item">S/N</span>
          <span class="item">Swath No</span>
          <span class="item">Swath Name</span>
          <span class="item">Swath Description</span>
          <span class="item">Action</span>
  
        </div>
  
      <div class="scroll">
  
      </div>
      <div class="body_content" >
        <div class="the_body"
        *ngFor="let seismicswathno of seismicswathnoFormArray.get('SeismicSwathNos')['controls']; index as i"
        (click)="onEdit(i, seismicswathno.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{i + 1}}</span>
          <span class="content">{{seismicswathno.value.SwathNo}}</span>
          <span class="content">{{seismicswathno.value.SwathName}}</span>
          <span class="content">{{seismicswathno.value.SwathDescription}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"
  
            (click)="deleteSeismicSwathNo(i, seismicswathno.value)">
            <em class="ti-trash"> </em> </button>
          </span>
  
        </div>
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit(seismicswathnoFormArray.value)">Submit</button>
        </div>
      </div>
    </div>
  </main>
  
  <div class="box green_box"></div>
  <div class="box pink_box"></div>
  